import { takeLatest, call, put } from 'redux-saga/effects';

import {
  GET_PRODUCT_PAGE_START,
  GET_PRODUCT_PAGE_ERROR,
  GET_PRODUCT_PAGE_SUCCESS,
} from '../actions/productPage';
import api from '../api';

function createGetProductPage() {
  return function* (option) {
    const { testCode, language } = option.payload;

    try {
      const data = yield call(() =>
        api.getProductPage(testCode, language),
      );
      const action = { type: GET_PRODUCT_PAGE_SUCCESS, data };

      yield put(action);
    } catch (error) {
      const action = { type: GET_PRODUCT_PAGE_ERROR, error };

      yield put(action);
    }
  };
}

function* getProductPageWatcher() {
  yield takeLatest(GET_PRODUCT_PAGE_START, createGetProductPage());
}

const productPageSagas = [getProductPageWatcher()];

export default productPageSagas;
